import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const connectionString = "__APPINSIGHTS_CONNECTION_STRING__";
const isValidConnectionString =
  connectionString && !connectionString.startsWith("__");

export const appInsights = isValidConnectionString
  ? new ApplicationInsights({
      config: {
        connectionString: connectionString,
        enableAutoRouteTracking: true, // tracks SPA page views on route change
        disableFetchTracking: false, // auto-adds traceparent to all fetch calls → BE correlation
        enableCorsCorrelation: true, // sends correlation headers cross-origin too
        correlationHeaderDomains: [window.location.hostname],
      },
    })
  : null;

if (appInsights) {
  appInsights.loadAppInsights();

  // Capture console.error calls → Azure Portal > Logs > exceptions table
  // (unhandled errors and promise rejections are tracked automatically by the SDK)
  const originalConsoleError = console.error;
  console.error = (...args) => {
    const error = args[0] instanceof Error ? args[0] : new Error(args.map(String).join(" "));
    appInsights.trackException({ exception: error, severityLevel: 3 });
    originalConsoleError.apply(console, args);
  };

  // Capture console.warn calls → Azure Portal > Logs > traces table (severityLevel 2 = Warning)
  const originalConsoleWarn = console.warn;
  console.warn = (...args) => {
    appInsights.trackTrace({ message: args.map(String).join(" "), severityLevel: 2 });
    originalConsoleWarn.apply(console, args);
  };

}

/**
 * Returns the current App Insights session ID, or empty string if unavailable.
 * Used to forward as X-Session-Id header on API calls so the BE can correlate
 * its traces back to the FE session.
 */
export function getSessionId() {
  return appInsights?.context?.getSessionId?.() ?? "";
}
